<main class="flex-1 flex flex-col px-10 pt-6 mt-24">
  <header class="flex justify-between items-start mb-10">
    <h1 id="tracks-title" class="text-5xl font-bold text-lWhite">Trilhas</h1>

    <div class="relative flex justify-start items-center w-[32rem]">
      <label for="my-courses-search" class="sr-only">Encontre uma trilha</label>
      <l-icon class="absolute left-4 top-1/2 -translate-y-1/2 text-lSecondary">search</l-icon>
      <input
        id="my-courses-search"
        type="text"
        [(ngModel)]="searchQuery"
        name="myCoursesSearch"
        (input)="onSearchTermChange(searchQuery)"
        placeholder="Encontre uma trilha"
        class="w-full pl-12 pr-4 py-2 rounded-3xl bg-lGray900 text-lWhite text-lg border border-lGray600 focus:outline-none focus:border-lPrimary"
      />
    </div>
  </header>

  <hr class="border-lPurple300 mb-4">

  <section class="mt-6">
    @if (isLoading) {
      <div class="flex min-h-[35vh] items-center justify-center">
        <l-spinner />
      </div>
    } @else if (tracks.length > 0) {
        <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          @for (track of tracks; track $index) {
            <l-track-card [track]="track" />
          }
        </div>
    } @else {
      <div class="min-h-[35vh] flex flex-col items-center gap-4 mt-20">
        <p class="text-lGray600 light:text-lSecondary text-lg">Nenhuma trilha encontrada.</p>
      </div>
    }
  </section>
</main>

